import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'tde-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {

  isLayoutVisible: boolean = true;

  constructor(private readonly _layoutService: LayoutService) { }

  ngOnInit(): void {
    
    this.isLayoutVisible = this._layoutService.getLayoutVisibility();
  }

}
